import { ViewerImage } from 'app/components/Viewer/types';
import { isAcquisitionImage } from 'app/utils/isAcquisitionImage';
import isWorkListImage from 'app/utils/isWorkListImage';
import _ from 'lodash';

export default function isAnyImagePresentInImages(
  images: ViewerImage[] | Record<string, ViewerImage>
): boolean {
  return _.some(
    images,
    (image: ViewerImage) =>
      !!image.displayableImage ||
      image.isImageLoading ||
      image.loadError ||
      isWorkListImage(image) ||
      isAcquisitionImage(image)
  );
}
